/**
 * History Service
 * API operations for task / note / obstruction history events
 */
import { apiClient } from './apiClient';
import { API_ENDPOINTS } from '@/constants/api';
import type { TaskHistoryResponse } from '@/types/api/responses';
import type { NoteHistoryResponse } from '@/types/notes';
import type { ObstructionHistoryResponse } from '@/types/obstructions';

export interface HistoryFilters {
  eventType?: string;
  authorId?: string;
  fromDate?: string;
  toDate?: string;
  page?: number;
  pageSize?: number;
}

export const historyService = {
  /**
   * Get history events for a task
   */
  getForTask: (taskId: string, filters?: HistoryFilters) =>
    apiClient.get<TaskHistoryResponse>(API_ENDPOINTS.HISTORY.BASE(taskId), {
      params: filters,
    }),

  /**
   * Get history events for a note
   */
  getForNote: (noteId: string) =>
    apiClient.get<NoteHistoryResponse>(API_ENDPOINTS.NOTE_HISTORY.BASE(noteId)),

  /**
   * Get history events for an obstruction.
   *
   * Thin client method — the matching backend endpoint
   * (`GET /api/v1/obstructions/{id}/history`) is scheduled for the obstruction
   * history follow-up (`plan.md` §1.7). Callers tolerate 404/501 responses
   * and fall back to an empty event list while the endpoint is wired.
   */
  getForObstruction: (obstructionId: string) =>
    apiClient.get<ObstructionHistoryResponse>(
      API_ENDPOINTS.OBSTRUCTIONS.HISTORY(obstructionId)
    ),
};
